import { FC, PropsWithChildren } from 'react';
import { EventRegistrationProvider } from '../../../../../../shared/frontend/scripts/events/providers/EventRegistrationProvider';
import {
  MediaContextProvider,
  MediaContextProviderV2
} from '../../../../../../shared/frontend/components/presentational/media';
import { InStreamVideoEligibilityProvider } from '../../../../../../shared/frontend/components/ads/instreamVideoContext';

export const CommonProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <MediaContextProvider>
      <MediaContextProviderV2>
        <InStreamVideoEligibilityProvider>
          <EventRegistrationProvider>{children}</EventRegistrationProvider>
        </InStreamVideoEligibilityProvider>
      </MediaContextProviderV2>
    </MediaContextProvider>
  );
};
